import styled from 'styled-components';

export const Button = styled.button<{ variant: 'primary' | 'outline'; block: boolean }>`
  display: inline-flex;
  align-items: end;
  justify-content: center;
  gap: 6px;
  font-size: 0.9rem;
  font-weight: 400;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  width: ${(props) => (props.block ? '100%' : 'auto')};
  white-space: nowrap;

  ${(props) =>
    props.variant === 'primary'
      ? `
    background: #007bff;
    border: 1px solid #007bff;
    color: #fff;
    &:hover { background: #0069d9; border-color: #0062cc; }
  `
      : `
    background: #fff;
    border: 1px solid #007bff;
    color: #007bff;
    &:hover { background: #f0f7ff; }
  `}

  .material-icons {
    font-size: 16px;
  }

  .academy-btn-icon {
    width: 16px;
    height: 16px;
    display: block;
  }

  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;
